module.exports = __webpack_public_path__ + "static/media/remove-account.00bc06f4.svg";